<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { useI18n } from "vue-i18n";

const store = useAppStore();
const { t } = useI18n();
</script>

<template>
  <div class="browser-frame" :class="{ 'browser-frame--mobile': store.deviceMode === 'mobile' }">
    <div class="browser-frame__bar" aria-hidden="true">
      <span class="browser-frame__dot browser-frame__dot--red"></span>
      <span class="browser-frame__dot browser-frame__dot--yellow"></span>
      <span class="browser-frame__dot browser-frame__dot--green"></span>
      <span class="browser-frame__address">{{ t("common.exampleDomain") }}</span>
    </div>
    <div class="browser-frame__content"><slot /></div>
  </div>
</template>

<style scoped>
.browser-frame {
  width: 100%;
  max-width: 720px;
  min-height: 480px;
  overflow: hidden;
  border: 1px solid var(--gray-200, #eaecf0);
  border-radius: 8px;
  background: var(--base-white, #fff);
  transition: max-width 160ms ease;
}
.browser-frame--mobile { max-width: 390px; }
.browser-frame__bar {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  border-bottom: 1px solid var(--gray-200, #eaecf0);
}
.browser-frame__dot { width: 8px; height: 8px; border-radius: 50%; }
.browser-frame__dot--red { background: #f04438; }
.browser-frame__dot--yellow { background: #f79009; }
.browser-frame__dot--green { background: #12b76a; }
.browser-frame__address {
  flex: 1;
  margin-left: 4px;
  padding: 3px 8px;
  border: 1px solid var(--gray-200, #eaecf0);
  border-radius: 6px;
  color: var(--gray-500, #667085);
  font-size: 12px;
}
.browser-frame__content { min-height: 440px; padding: 24px; }
</style>
